export const inboundLeadEmailOutcomes = [
    "pending",
    "created",
    "noData",
    "failed",
];
export const unconvertedInboundLeadEmailOutcomes = ["noData", "failed"];
//# sourceMappingURL=inbound-lead-email-outcome.js.map